import {
  Box,
  Button,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Stack,
  Textarea,
  useDisclosure,
} from "@chakra-ui/react";
import { useState } from "react";
import { BiText } from "react-icons/bi";
import { addStory } from "../service";

export const StoriesModal = ({ acctType, reload }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState("");
  const [color, setColor] = useState("#ffffff");
  const [colorList] = useState([
    "linear-gradient(90deg, rgba(65,88,208,1) 0%, rgba(200,80,192,0.8253895308123249) 81%)",
    "linear-gradient(90deg, rgba(0,147,233,1) 0%, rgba(128,208,199,1) 81%)",
    "linear-gradient(90deg, rgba(139,139,139,1) 0%, rgba(77,38,96,1) 44%)",
    "linear-gradient(0deg, rgba(34,193,195,1) 0%, rgba(253,187,45,1) 100%)",
  ]);

  const [background, setBackground] = useState(colorList[0]);

  const handleSendStory = async () => {
    const payload = {
      type: "text",
      text: content,
      color,
      background,
    };
    setLoading(true);
    await addStory(payload, onClose, setLoading).then(() => reload());
  };

  return (
    <>
      <Flex justify={"center"} onClick={onOpen} cursor="pointer" width="100%">
        {" "}
        <BiText color="#0276fc" size={22} />
      </Flex>
      <Modal isOpen={isOpen} onClose={onClose} size="sm" isCentered>
        <ModalOverlay />
        <ModalContent height={"500px"}>
          <Stack
            direction={"row"}
            alignItems="center"
            mb="10px"
            p="5px 5px 0 5px"
          >
            {colorList?.map((color) => {
              return (
                <Box
                  border={color === background ? "2px solid #5353ff" : "none"}
                  cursor="pointer"
                  w="25px"
                  h="25px"
                  borderRadius={"50%"}
                  bg={color}
                  onClick={() => setBackground(color)}
                />
              );
            })}
          </Stack>
          <ModalCloseButton />
          <ModalBody
            p="20px"
            bg={background}
            borderTopRightRadius={"10px"}
            borderTopLeftRadius={"10px"}
          >
            <Flex
              direction={"column"}
              width="100%"
              height="350px"
              justify="center"
              align="center"
            >
              <Textarea
                color={color}
                bg="inherit"
                width="100%"
                height="40%"
                textAlign={"center"}
                vertical-align="middle"
                placeholder="Enter your story"
                _placeholder={{ color: "#d8d8d8" }}
                whiteSpace={"normal"}
                resize="none"
                className="scroll-container"
                value={content}
                onChange={(e) => setContent(e.target.value)}
              />
            </Flex>
          </ModalBody>

          <Button
            borderRadius={"none"}
            bg="#5353ff"
            _hover={{ background: "#5353ff" }}
            color="#fff"
            isLoading={loading}
            onClick={handleSendStory}
            isDisabled={!content}
          >
            Done
          </Button>
        </ModalContent>
      </Modal>
    </>
  );
};
